import React from 'react';
import { Link } from 'gatsby';

type LooxRatingProps = {
  link: string;
  shopifyId: string;
};

const LooxRating = (props: LooxRatingProps) => {
  const { link, shopifyId = '' } = props;

  return (
    <Link
      className="typography-body-s lg:typography-body-m !text-cerulean-400 pb-[20px] lg:pb-[30px] no-underline
        [&>span]:typography-body-s lg:[&>span]:typography-body-m ![&>span]:text-cerulean-400"
      to={link}
    >
      {/* min-h reserves space for Loox's star-rating widget, which fetches and injects its
          markup into this div asynchronously — without a reserved height, that injection is a
          real layout shift (the dominant CLS contributor measured on /shop). */}
      <div className="loox-rating min-h-[20px]" data-fetch data-id={shopifyId.replace('gid://shopify/Product/', '')} />
    </Link>
  );
};

export default React.memo(LooxRating);
